<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            background-color="#242f42"
            text-color="#bfcbd9"
            active-text-color="#20a0ff"
            unique-opened
            router
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <!--                            class="side-title-box"-->
                            <div
                                :class="{
                                    'side-title-box': collapse === false,
                                    'side-title-box-padding': collapse === true
                                }"
                            >
                                <svg class="icon" style="font-size: 22px" aria-hidden="true">
                                    <use :xlink:href="item.icon"></use>
                                </svg>
                                <span v-if="!collapse" slot="title" style="margin-left: 16px">
                                    <div v-if='ir==1'>
                                        {{item.title=='成考考前辅导' ?'招生备案管理':item.title  }}
                                    </div>
                                    <div v-else>
                                        {{item.title}}
                                    </div>
                                </span>
                            </div>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">
                                    {{ subItem.title }}
                                </template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">{{
                                    threeItem.title
                                }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <div
                            :class="{
                                'side-title-box': collapse === false,
                                'side-title-box-padding': collapse === true
                            }"
                        >
                            <svg class="icon" style="font-size: 22px" aria-hidden="true">
                                <use :xlink:href="item.icon"></use>
                            </svg>
                            <span v-if="!collapse" slot="title" style="margin-left: 16px">{{ item.title }}</span>
                        </div>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: false,
            account_type: 0,
            items: [],
            menu_tree: [],
            org: 0,
            ir: 0,
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', (msg) => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
        this.getAccountType();
    },
    methods: {
        getAccountType() {
            let base64_str = window.localStorage.getItem('menu_tree');
            let menu_tree = this.$base64.decode(base64_str);
            this.ir = window.localStorage.getItem("ir")
            this.org = window.localStorage.getItem("org")
            this.menu_tree = JSON.parse(menu_tree);
            this.menu_tree.unshift({ icon: '#icon-xitongshouye-h', index: 'index', title: '系统首页' });
            // this.menu_tree.unshift({ icon: '#icon-xitongshouye-h', index: 'reportCheck', title: '报告管理' });
            this.items = this.menu_tree;
        }
    }
};
</script>

<style scoped>
.side-title-box {
    display: flex;
    align-items: center;
}
.side-title-box-padding {
    padding-top: 50%;
    display: flex;
    align-items: center;
}
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}
.sidebar > ul {
    height: 100%;
}
</style>
